var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { ChoiceOption } from '../ChoiceOption/ChoiceOption';
export class ChoiceEdit {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get canAddOption() {
        return this.question.choiceStore.numberOfOptions < 100;
    }
    get canRemoveOption() {
        return this.question.choiceStore.numberOfOptions > 2;
    }
    addOption() {
        this.question.choiceStore.numberOfOptions++;
        if (this.question.choiceStore.numberOfOptions >= this.question.options.length) {
            const newOption = ChoiceOption.fromSerialized({ parent: this.question });
            this.question.choiceStore.allOptions.push(newOption);
        }
    }
    removeOption() {
        this.question.choiceStore.numberOfOptions--;
    }
}
__decorate([
    action.bound
], ChoiceEdit.prototype, "addOption", null);
__decorate([
    action.bound
], ChoiceEdit.prototype, "removeOption", null);
